// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BaP3","toggle":"styles_toggle__3UET6","preview":"styles_preview__FYQko"};